// extracted by mini-css-extract-plugin
module.exports = {"titleCell":"BpQEiQ4d","descriptionCell":"WeaYTHKE","numberCell":"lruxBXht","title":"UKKZiAam"};